import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import getFlagValue, { FLAG_ENUM } from '../../../helpers/utils/getFlagValue';

export default function useSetHardwerdId() {
  const [isInterracted, setIsInterreacted] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const position = window.scrollY;
      if (position > 0) {
        setIsInterreacted(true);
      }
    };

    const handleInteract = () => {
      setIsInterreacted(true);
    };

    if (!isInterracted) {
      window.addEventListener('scroll', handleScroll, { passive: true });
      window.addEventListener('touchmove', handleScroll, { passive: true });
      window.addEventListener('mousemove', handleInteract);
      window.addEventListener('touchstart', handleInteract);
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('touchmove', handleScroll);
      window.removeEventListener('mousemove', handleInteract);
      window.removeEventListener('touchstart', handleInteract);
    };
  }, [isInterracted]);

  useEffect(() => {
    const isFlagActive = getFlagValue(FLAG_ENUM.EMARSYS);
    const isFlagEmarsysWebPush = getFlagValue(FLAG_ENUM.EMARSYS_WEB_PUSH);
    if (
      isFlagActive &&
      isFlagEmarsysWebPush &&
      typeof WebEmarsysSdk !== 'undefined' &&
      WebEmarsysSdk &&
      WebEmarsysSdk?.getClientId
    ) {
      WebEmarsysSdk?.getClientId().then((clientId) => {
        if (clientId) {
          Cookies.set('hardwareId', clientId);
        }
      });
    }
  }, [isInterracted]);

  return null;
}
